import script from "./CInputUdcList.vue?vue&type=script&setup=true&lang=js"
export * from "./CInputUdcList.vue?vue&type=script&setup=true&lang=js"

import "./CInputUdcList.vue?vue&type=style&index=0&id=15a2be3b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15a2be3b"]])

export default __exports__